import { Component, OnInit } from '@angular/core';
import { ContentStatusEnum } from '@urbannex/storethemes';

@Component({
  selector: 'ngx-margin-popover',
  standalone: false,
  templateUrl: './margin-popover.component.html',
  styleUrl: './margin-popover.component.scss'
})
export class MarginPopoverComponent {
  title:string;
  color:string;
  colors:any[];
  content:any;
  target:string;
  property:string;
  status:ContentStatusEnum;
  service:string;
}
